import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredPoolVehicleList } from 'types/PoolVehicleType'
import { InputWrapper, StyledInputText } from './styled'
import poolVehicleIcon from 'assets/icons/pool-vehicle-gray.svg'

interface IPoolVehicleSearchProps {
  vehicles: IFilteredPoolVehicleList[] | []
  setSearchText: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<IFilteredPoolVehicleList[] | []>>
  searchText: string
}

export default function PoolVehicleSearch({ vehicles, setData, searchText, setSearchText }: IPoolVehicleSearchProps) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter vehicles by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['plate', 'brandOfVehicle', 'modelOfVehicle']
      const lowercasedValue = value.toLowerCase().trim()
      if (lowercasedValue === '') setData(vehicles)
      else {
        const filteredData = vehicles?.filter((item: IFilteredPoolVehicleList) => {
          return Object.keys(item).some((key) =>
            includeColumns.includes(key)
              ? item[key as keyof IFilteredPoolVehicleList].toString().toLowerCase().includes(lowercasedValue)
              : false
          )
        })
        setData(filteredData)
      }
    },
    [vehicles, setData]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles])

  const disabled = !vehicles?.length

  return (
    <InputWrapper className="p-input-icon-left">
      <img src={poolVehicleIcon} alt="pool-vehicle-search" className="input-icon" width={20} height={20} />
      <StyledInputText
        id="pool-vehicle-room-search"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('input-texts.search-pool-vehicle')}
      />
    </InputWrapper>
  )
}
